function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12908",
    style: {
      fill: "#c2e7eb",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313112px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 4.0774305,0.11239676 5.1811707,1.0392982 M 0.15028581,0.14902649 H 4.0251666 V 1.0759398 H 5.1289068 V 6.4504842 H 0.15028581 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse17983",
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.29014,
      strokeLinecap: "square"
    },
    d: "M 3.8796227,4.0177783 A 1.384705,1.4020924 0 0 1 2.4949177,5.4198707 1.384705,1.4020924 0 0 1 1.1102129,4.0177783 1.384705,1.4020924 0 0 1 2.4949177,2.6156858 1.384705,1.4020924 0 0 1 3.8796227,4.0177783 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2.6579431,3.2429903 q 0,0.066465 -0.049944,0.1242606 -0.048517,0.056351 -0.1070229,0.056351 -0.067068,0 -0.1098769,-0.040457 -0.042809,-0.040457 -0.042809,-0.1054771 0,-0.063575 0.051371,-0.1184811 0.052798,-0.054906 0.1127308,-0.054906 0.1455512,0 0.145551,0.1387096 z m 0.1583941,1.6356168 q -0.00714,0.041901 -0.034247,0.047681 -0.00714,0.00145 -0.068495,-0.00289 -0.212619,-0.014449 -0.4181031,0.00578 -0.055652,0.00578 -0.069922,-0.00434 -0.01427,-0.010114 -0.01427,-0.046236 0,-0.033233 0.075629,-0.054906 0.082765,-0.024564 0.082765,-0.1603829 V 4.2847569 q 0,-0.1141464 -0.022832,-0.160383 -0.031393,-0.063575 -0.1298545,-0.096807 -0.044236,-0.015894 -0.044236,-0.047681 0,-0.041901 0.064214,-0.06213 0.1198657,-0.037567 0.2126189,-0.099697 0.074203,-0.052016 0.091327,-0.052016 0.057079,0 0.055652,0.075134 -0.0057,0.3785615 -0.0057,0.7715718 0,0.093918 0.027112,0.134375 0.029966,0.044791 0.1141578,0.063575 0.092753,0.021674 0.084192,0.06791 z",
    id: "path839",
    style: {
      fontSize: "2.94075px",
      lineHeight: 1.25,
      fontFamily: "'High Tower Text'",
      InkscapeFontSpecification: "'High Tower Text, Normal'",
      fill: "#343434",
      strokeWidth: 0.0735178
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOn);
export default __webpack_public_path__ + "static/media/info_on.6bc5ffe380c781b5850b14d97e68705a.svg";
export { ForwardRef as ReactComponent };